const toCamelCase = (str) => {
  return str
    .replace(/[^a-zA-Z0-9 ]/g, '') // remove non-alphanumeric except space
    .split(' ')
    .map((word, index) => {
      if (index === 0) {
        return word.charAt(0).toLowerCase() + word.slice(1);
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join('');
};

// Module Slug is api end point and Path is frontend route endpoint. 

const routes = [
  {
    key: "dashboard",
    module_name: "Dashboard",
    module_slug: "/dashboard",
    isProtected: true,
    isInsideMainLayout: true,
    path : "/"
  },
  // {
  //   key: "dashboardStatic",
  //   module_name: "Dashboard Static",
  //   module_slug: "/dashboard",
  //   isProtected: true,
  //   isInsideMainLayout: true,
  // },
  {
    key: "userManagement",
    module_name: "User Management",
    module_slug: "/users",
    isProtected: true,
    isInsideMainLayout: true,
    path : "/users"
  },
  {
    key: "adminUserManagement",
    module_name: "Admin User Management",
    module_slug: "/users",
    isProtected: true,
    isInsideMainLayout: true,
    path : "/admin-users"
  },
  {
    key: "roleManagement",
    module_name: "Role Management",
    module_slug: "/roles",
    isProtected: true,
    isInsideMainLayout: true,
    path : "/roles"
  },
  {
    key: "subscriptionManagement",
    module_name: "Subscription Management",
    module_slug: "/subscriptions",
    isProtected: true,
    isInsideMainLayout: true,
    path : "/subscriptions"
  },
  {
    key: "adsManagement",
    module_name: "Ads Management",
    module_slug: "/ads",
    isProtected: true,
    isInsideMainLayout: true,
    path : "/ads"
  },
  {
    key: "cmsPage",
    module_name: "CMS Page",
    module_slug: "/cms/*",
    isProtected: true,
    isInsideMainLayout: true,
    path : "/cms/*"
  },
  {
    key: "contentList",
    module_name: "Content List",
    module_slug: "/cms/contents/:id",
    isProtected: true,
    isInsideMainLayout: true,
    path : "/cms/contents/*"
  },
  {
    key: "contactUsManagement",
    module_name: "Contact Us Management",
    module_slug: "/contact-us",
    isProtected: true,
    isInsideMainLayout: true,
    path : "/contact-us-management"
  },
  {
    key: "petStoreManagement",
    module_name: "Pet Store",
    module_slug: "/choose-pet",
    isProtected: true,
    isInsideMainLayout: true,
    path : "/pets"
  },
  {
    key: "accessoriesManagement",
    module_name: "Accessories Store",
    module_slug: "/accessories",
    isProtected: true,
    isInsideMainLayout: true,
    path : "/accessories"
  },
  {
    key: "soundManagement",
    module_name: "Sound",
    module_slug: "/choose-sound",
    isProtected: true,
    isInsideMainLayout: true,
    path : "/choose-sound"
  }
];

export { routes };
